import { useQuery } from '@tanstack/react-query';
import { getInvitations } from '../api/shared-documents.api';

export const useInvitationsInit = ({ isOpen = false }: { isOpen?: boolean }) => {
	const {
		data: documentAccesses,
		error,
		isPending,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['GET_INVITATIONS'],
		queryFn: () => getInvitations(),
		enabled: isOpen,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

	return {
		documentAccesses,
		error,
		isPending,
		isLoading,
		isError,
	};
};
